import { RelationSettingsService } from '@/modules/global-settings/miscellaneous/services/relation-settings.service';
import { make } from 'vuex-pathify';
import Logger from '@/lib/logger';
// Create a new instance of the RelationSettingsService class
const relationService = new RelationSettingsService();
// Relation Types module state
export const state = {
  relationSettings: []
};
// Relation Types module mutations
export const mutations = {
  ...make.mutations(state)
};
// Relation Types module actions
export const actions = {
  /**
   * Fetches all Relation Types
   * @param {Object} context - Vuex action context
   * @returns {Array} Array of Relation Types
   *
   * @private This sets the Relation Types in the state
   */
  getRelationTypes: async ({ commit }) => {
    try {
      const { data } = await relationService.getRelationTypes();
      commit('SET_RELATION_SETTINGS', data);
      return data;
    } catch (error) {
      Logger.error('getting relation settings');
      throw error;
    }
  },

  /**
   * Creates a Relation Type
   * @param {Object} context - Vuex action context
   * @param {Object} payload - Relation payload
   *  @returns {Number} HTTP status code
   *
   * @private This will re-fetch the Relation Types & set the state
   */
  createRelationTypes: async ({ dispatch }, payload) => {
    try {
      const { data } = await relationService.createRelationTypes(payload);
      dispatch('getRelationTypes');
      return data;
    } catch (error) {
      Logger.error('creating relation settings');
      throw error;
    }
  },

  /**
   * Updates a Relation Type
   * @param {Object} context - Vuex action context
   * @param {Object} payload - Relation payload
   * @param {String} payload.id - Relation ID
   * @param {Object} payload.payload - Relation updates
   * @returns {Number} HTTP status code
   *
   * @private This will re-fetch the Relation Types & set the state
   */
  updateRelationTypes: async ({ dispatch }, { id, payload }) => {
    try {
      await relationService.updateRelationTypes(id, payload);
      dispatch('getRelationTypes');
    } catch (error) {
      Logger.error('updating relation settings');
      throw error;
    }
  },

  /**
   * Updates a Relation Type
   * @param {Object} context - Vuex action context
   * @param {Object} payload - Relation payload
   * @param {String} payload.id - Relation ID
   * @param {Object} payload.payload - Relation updates
   * @returns {Number} HTTP status code
   *
   * @private This will re-fetch the Relation Types & set the state
   */
  deleteRelationType: async ({ dispatch }, id) => {
    try {
      await relationService.deleteRelationType(id);
      dispatch('getRelationTypes');
    } catch (error) {
      Logger.error('updating relation settings');
      throw error;
    }
  },


};
// Relation Types module getters
export const getters = {
  ...make.getters(state),
  activeRelationSettings(state) {
    return state.relationSettings.filter((r) => r.status == true);
  }
};
